import gql from 'graphql-tag';

export const updateNoteType = gql`
  mutation updateNoteType(
    $categories: [String]
    $enabled: Boolean
    $id: String
    $name: String
    $aors: [String]
  ) {
    updateNoteType(
      categories: $categories
      enabled: $enabled
      id: $id
      name: $name
      aors: $aors
    ) {
      createdBy
      createdDate
      active
      id
      name
      updatedBy
      updatedDate
      version
      aors {
        name
        id
      }
      Categories {
        id
        name
      }
    }
  }
`;
